import { observer } from 'mobx-react';
import clsx from 'clsx';
import InvitationStore from '../../Store/InvitationStore';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';
import { ConfirmingDeactivate } from '../../Store/InvitationStore/Types';
import ParticipantInfo from './ParticipantInfo';

interface Props {
  state: ConfirmingDeactivate;
  store: InvitationStore;
}

function DeactivateConfirmation({ state, store }: Props) {
  return (
    <>
      <h3 className="mb-3 text-xl font-semibold">
        <T kind="Remove Collection Access" />
      </h3>
      <ParticipantInfo state={state} />
      <p
        className={clsx(
          'my-6 rounded border-1 border-solid border-teal-400 bg-teal-500 px-4 py-3',
          'text-sm text-gray-800',
        )}
      >
        <T kind="This participant will no longer be able to..." />
      </p>
      <Button
        type="button"
        value="Submit"
        onClick={store.deactivating}
        className={clsx(
          'rounded-md border border-solid border-gray-900 bg-white',
          'py-2.5 px-5 text-sm font-semibold text-gray-900',
        )}
      />
    </>
  );
}

export default observer(DeactivateConfirmation);
